export function mediaQuery(breakPoint: string) {
  return window.matchMedia('(min-width: ' + breakPoint + 'px)');
}
